import CRM_MAIL_STATUS from '../../constants-v2/crm/crm-mail-status';
import CrmMailApi from '../../../api-v2/crm/mailing/crm-mails';
import HttpBuildQuery from '../../procedures/http-build-query';
import FiltersType from './listingFiltersTypesConstants';
import MAIL_TYPE from '../../constants-v2/crm/mailing-type';
import store from '../../store/store';

export default {
  path: '/mailing/inbox',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'hub_filter_search',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: 'status',
      getItems: async () => [
        { value: CRM_MAIL_STATUS.SENT, label: 'Nieprzeczytane' },
        { value: CRM_MAIL_STATUS.READ, label: 'Przeczytane' },
      ],
      reset: async () => null,
      placeholder: 'Status',
      badge: 'Status',
      testName: 'test_filter_mailing_inbox_status',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: 'mail_type',
      getItems: async () => [
        { value: MAIL_TYPE.MANUAL, label: 'Ręczny' },
        { value: MAIL_TYPE.SYSTEM, label: 'Systemowy' },
      ],
      reset: async () => null,
      placeholder: 'Typ',
      badge: 'Typ',
      testName: 'test_filter_mailing_inbox_type',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: '_sent_at_date',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Data otrzymania:',
      testName: 'test_filter_mailing_inbox_sent_at',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'date',
    },
    {
      key: '_mail_sender_multi',
      getItems: async () => {
        let { data } = await CrmMailApi.index(HttpBuildQuery({ list: true }));
        delete data.pagination;

        return Object.values(data)
          .map((item) => {
            return {
              value: item.sender_original,
              label: item.sender_name,
            };
          }).filter((o, index, arr) =>
            arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
          );
      },
      reset: async () => null,
      placeholder: 'Nadawca',
      badge: 'Nadawca:',
      testName: 'test_filter_mailing_inbox_sender',
      inputType: FiltersType.MULTI_SELECT_TYPE,
    },
    {
      key: '_show_only_mine',
      getItems: async () => [
        { value: 0, label: 'NIE' },
        { value: 1, label: 'TAK' },
      ],
      reset: async () => null,
      visible: () => !store.getters['auth/isUserCrm'],
      placeholder: 'Pokaż tylko moje',
      badge: 'Pokaż tylko moje:',
      testName: 'test_filter_mailing_inbox_show_only_mine',
      inputType: FiltersType.SELECT_TYPE,
    },
  ]
}